import TextFieldControl from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";
import ReportSwitch from "../../components/ReportSwitch";

interface GroupAndOpenLeftProps {
  isCreate: boolean;
}

const GroupAndOpenLeft = ({ isCreate }: GroupAndOpenLeftProps) => {
  return (
    <>
      <ReportSwitch />
      <TextFieldControl
        name='title'
        label='Название тестирования'
        rules={{ ...VALIDATION.competencyMapTitle }}
        disabled={!isCreate}
      />
      <TextFieldControl
        name='createdAt'
        label='Дата создания тестирования'
        disabled
      />
    </>
  );
};

export default GroupAndOpenLeft;
